export default __webpack_public_path__ + "static/tour_09_feedback-59395ea28b69deaa6c64f78a37b98ec2.jpg";